import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AddPhotoConstants as ui } from '../../Config/UIConstants';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { ModalActionButtonBar } from '../../SharedComponents/ModalActionButtonBar';
import { RemovalConfirmationPopup } from '../../SharedComponents/RemovalConfirmationPopup';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { AbstractAddPhotosPage } from '../AddPhotosPage/AbstractAddPhotosPage';
import { styles } from './AddPhotosStyle';

interface IProps extends RouteComponentProps<any> {
    store: ApplicationStore;
}

@inject('store')
@observer
export class AddPhotosPage extends AbstractAddPhotosPage<IProps> {
    protected renderEmptyPhotosHeader() {
        return <p style={styles.headerContainer}>{ui.HEADER}</p>;
    }

    protected renderPhotosHeader() {
        return <p style={styles.addPhotosHeaderText}>{ui.ADD_PHOTOS_HEADER}</p>;
    }

    protected renderPhotosBottomBar() {
        return <ModalActionButtonBar confirmOnClick={() => this.uploadAllImages()} confirmContent={ui.CONFIRM_TEXT} style={styles.actionButtonBar} />;
    }

    protected onFinishedUploadedPhotosCallback(): Promise<void> {
        this.props.history.push(Routes.PHOTOS);
        return Promise.resolve();
    }

    public render() {
        return (
            <FullScreenModalContainer
                {...this.props}
                justifyContent="space-between"
                alignItems="center"
                onPressExit={() => this.setState({ showExitConfirm: true })}
            >
                {this.renderContent()}
                {this.state.showExitConfirm && (
                    <RemovalConfirmationPopup
                        headerText={ui.EXIT_HEADER}
                        subHeaderText={ui.EXIT_SUB_HEADER}
                        cancelText={ui.EXIT_CANCEL}
                        removeText={ui.EXIT_CONFIRM}
                        onClickCancel={() => this.setState({ showExitConfirm: false })}
                        onClickRemove={() => this.props.history.push(Routes.PHOTOS)}
                    />
                )}
            </FullScreenModalContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/PhotosPage/AddPhotosPage.tsx